// Публичный фасад поверх Supabase SDK (JWT текущего пользователя).
import { rpc } from "@/lib/rpc/client";

type RpcArgs = Record<string, unknown> | undefined;
export type LegacySingle<T> = { data: T | null; error: unknown | null };

function toSafeError(e: unknown) {
  // Сужаем до безопасного формата
  if (e && typeof e === "object" && "message" in e) {
    const msg = (e as any).message ?? "Unknown error";
    return { message: String(msg), code: (e as any).code ?? "ERR_RPC" };
  }
  return { message: "Unknown error", code: "ERR_RPC" };
}

// Совместимо с существующим toLegacySingle-использованием
export async function publicCallSingle<T = unknown>(
  functionName: string,
  args?: RpcArgs
): Promise<LegacySingle<T>> {
  try {
    const cleanArgs = args ? Object.fromEntries(Object.entries(args).filter(([_, v]) => v !== null && v !== undefined)) : {};
    const { data, error } = await rpc<T>(functionName, cleanArgs);
    return { data: (error ? null : (data ?? null)) as T | null, error: error ? toSafeError(error) : null };
  } catch (e) {
    return { data: null, error: toSafeError(e) };
  }
}

// На будущее: списочные RPC (BFF-обёртка)
export async function publicCallList<T = unknown>(
  functionName: string,
  args?: RpcArgs
): Promise<LegacySingle<T[]>> {
  return publicCallSingle<T[]>(functionName, args);
}

// Прямой доступ при необходимости
export { rpc as publicRpc };